<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      采购订单管理
      <small>/采购订单详情</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">采购订单详情</h4>
              </div>
              <!-- end panel-heading -->
              <el-card class="box-card">
              <div>
              <form  style="margin-top:16px;" >
                <fieldset>
            <div class="form-group row m-b-15">
                   <label class="col-md-1 col-form-label">品牌</label>
                    <div class="col-md-2">
                      <v-selectpage
                        title=""
                        :data="brandNameList"
                        key-field="brandId"
                        show-field="brandName"
                        placeholder="请选择"
                        v-model="brandId"
                        @values="getSeriesInfo"
                        style="70%;"
                    ></v-selectpage>
                    </div>
                     <label class="col-md-1 col-form-label">系列</label>
                    <div class="col-md-2">

                    <v-selectpage
                        title=""
                        :data="seriesNameList"
                        key-field="seriesId"
                        show-field="seriesName"
                        placeholder="请选择"
                        v-model="seriesId"
                        style="70%;"
                    ></v-selectpage>
                    </div>
                   <label class="col-md-1 col-form-label">商品名称</label>
                    <div class="col-md-2">
                       <v-selectpage
                        title=""
                        :data="goodsNameList"
                        key-field="goodsId"
                        show-field="goodName"
                        placeholder="请选择"
                        v-model="goodsId"
                        @values="getGoodsInfo"
                        style="70%;"
                    ></v-selectpage>
                    </div>
                  
                    <div class="col-md-1">
                      <a
                        class="btn btn-primary ButtonColor m-r-5"
                        @click="SearchClick()"
                        style="float:right;"
                      >查询</a>
                    </div>
                    <div class="col-md-11"></div>
                    <div  class="col-md-1">
                    <!-- <el-button
                      class="btn btn-primary btn-sm m-l-1 ButtonColor bot-btn-left a_class"
                      @click="exp()"
                    >导出</el-button> -->
                  </div>
            </div>
                </fieldset>
              </form>
                    <el-table
                      :data="tableData3"
                      style="width: 100%"
                      size="medium"
                      border
                      :header-cell-style="{background:'#ffffff'}"
                    >
                      <el-table-column
                        width="50"
                        prop="goodsid"
                        label="序号"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        prop="brandName"
                        label="品牌"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                       <el-table-column
                        prop="seriesName"
                        label="系列"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        prop="goodsName"
                        label="商品名称"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        prop="outCount"
                        label="出库数量"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                    
                      <el-table-column
                        prop="recomName"
                        label="采购人"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        prop="inputTime"
                        label="采购时间"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                    </el-table>
                  <!-- 04 -->
                  <div class="bottom">
                    <div class="block">
                      <!---- totalCount  ------- pageSize   ----->
                      <el-pagination
                        :current-page="pageNo"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        background
                      ></el-pagination>
                    </div>
                  </div>
                  <div style="height:66px;padding-top:16px;padding-right:6px;">
                <a
                  class="btn btn-primary m-r-5"
                  style="float:right;cursor:pointer;color:#fff !important"
                  @click="Goback"
                >返&nbsp;&nbsp;回</a>

                <span class="clear"></span>
              </div>

                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
  
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
export default {
  name: "outbound",
  data() {
    return {
      // 对话框
      outerVisible: false,
      DialogTitle: "编辑",
      disabled: false,
      EditDialog: 1,
      goodsId:"",
      seriesId:"",
      brandId:"",
      ruleForm: { money: "5000" },
      CurrentSelection: [],
      seriesNameList:[],
      brandNameList:[],
      value1: "",
      pageNo: 1,
      // 当前显示 数据的数据量
      pageSize: 10,
      // 数据总数量  ---- 总条数
      totalCount: 0,
      // 上传合同，
      dialogImageUrl: "",
      dialogVisible: false,
      // 开始时间  （yyyy-MM-dd HH:mm:ss）
      startTime: "",
      // 结束时间  （yyyy-MM-dd HH:mm:ss）
      endTime: "",
      form: {
        //合同编号
        contractNo: "",
        // 合同标题
        contractTitle: "",
        recomName: ""
      },
      // 服务商名称
      recomNameList: [],
      goodsNameList: [],
      ruleForm: {
        contractNo: ""
      },
      rules: {
        TimeValue: [
          {
            required: false,
            message: "请选择查询时间",
            trigger: "change"
          }
        ]
      },
      Formdata: {
        // TimeValue: [new Date(2020, 0, 1), new Date()]
        TimeValue: ""
      },
      //   表格的 数据
      tableData3: [
        
      ],
      director:0
    };
  },
  mounted() {
      // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    this.initData();
    this.getBranNameInfo();
  },
  methods: {
    // 初始化数据
    initData() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobOrderController/queryOrderPages",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({
          recomId: that.recomName,
          orderNo: that.orderNo,
          startInputTime: that.startTime,
          endInputTime: that.endTime
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          if (response.data.data.records.length > 0) {
            this.tableData3 = response.data.data.records;
            this.totalCount = response.data.data.total;
          }
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
 Goback() {
      this.$router.push({
        name: this.url,
        params: { pageNo: this.pageNo, pagesize: this.pageSize }
      });
    },
    //品牌名称
    getBranNameInfo() {
      let that = this;
      const options = {
        url: "/distribution/B2cGoodsBrandController/queryBrand",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify({
          director: that.director
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          this.brandNameList = response.data.data.data;
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
   
   //系列名称
    getSeriesInfo(item) {
      let that = this;
      const options = {
        url: "/distribution/B2cGoodsInfoController/cascadeQuery",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify({
          director: that.director,
          brandId:item[0].brandId

        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          this.seriesNameList = response.data.data;
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    //系列名称
    getSeriesInfo(item) {
      let that = this;
      const options = {
        url: "/distribution/B2cGoodsInfoController/cascadeQuery",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify({
          director: that.director,
          brandId:item[0].brandId

        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          this.seriesNameList = response.data.data;
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    
    //获取商品
    getGoodsInfo(item) {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsInfoController/queryGoodsInfoByPage",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
           director: that.director,
          seriesId:item[0].seriesId,
           brandId:item[0].brandId
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.goodListName = response.data.data.data;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
  
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 查询数据
    SearchClick() {
      this.pageNo =1;
      this.initData();
    },
    // 新增
    AddClick() {
      this.$router.push({ name: "product", path: "/product" });
    },
    //删除
    modifyClick() {
      this.$router.push({ name: "EditProduct", path: "/editroduct" });
    },
    // 导出数据
    exp() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobOutController/outExport",
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        params: {}
      };
      axios(options)
        .then(function(response) {
          if (response.data.code !== undefined) {
            http.handleEorrorCode(response, that);
          } else {
            that.ExportClickSecond();
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    ExportClickSecond() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobOutController/outExport",
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        params: {},
        responseType: "blob"
      };
      axios(options)
        .then(function(response) {
          var filename = "出库订单列表" + new Date().getTime();
          let url = window.URL.createObjectURL(response.data);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename + ".xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    //出库详情的处理函数
    handleClick(row, index) {
      this.$router.push({
        path: "/outbounddetail",
        name: "outbounddetail",
        query: { outId: row.outId }
      });

      // console.log(row.barCode);
    },
    // 对话框的 【确定 】 处理函数
    MakeSure() {
      let that = this;
      that.disabled = true;
      axios
        .post(
          "distribution/B2cGoodsBrandController/deleteBrand?brandId=" +
            this.CurrentSelection.brandId
        )
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          that.disabled = false;
          http.handleHttpError(error, that);
        });
    },
    //   startTime  开始时间
    getstarttime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth() + 1; //得到月份
      var date = now.getDate(); //得到日期
      //   var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒

      if (now.getMonth() + 1) {
        if (month < 10) month = "0" + (now.getMonth() + 1);
        date = "0" + "1";
        hour = "0" + "0";
        minu = "0" + "0";
        sec = "0" + "0";
      }
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    // endtime;结束时间
    getEndtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    //  时间的处理函数
    ChangePicker() {
      if (this.Formdata.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.Formdata.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.Formdata.TimeValue[1]);
      } else if (this.Formdata.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    // 分页处理函数 分页-- 获取 每页  value条
    handleSizeChange(value) {
      this.pageSize = value;
      console.log(this.pageSize);
      this.pageNo = 1;
      this.initData();
    },
    //  获取 当前  value
    handleCurrentChange(value) {
      this.pageNo = value;
      console.log(this.pageNo);
      this.initData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.left {
  margin-left: 20px;
}
.upload {
  margin-top: 20px;
  margin-left: 13%;
  display: flex;
  justify-content: flex-start;
}
.upload_left {
  /* margin-top: 50px; */
  padding-right: 30px;
  letter-spacing: 1px;
}
/*  */
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.a_class {
  padding: 8px 12px;
}
.div_tab {
  margin-top: 6%;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.right_but {
  float: right;
  margin-top: 38px;
}
.InputWidth {
  width: 202px;
}
.top-hd {
  margin-top: 20px;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}

.bottom {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.bottom_table {
  display: flex;
  justify-content: flex-start;
}

.grid-content {
  border-radius: 4px;
  min-height: 20px;
}
.top-thone {
  margin-left: 20px;
  margin-top: 20px;
}
.btn1 {
  background-color: #fff;
}
.bot-btn {
  float: left;
  margin-left: 20.42%;
}
.bot-btn-left {
  margin-left: 70px;
}
.top-bot {
  float: left;
}
.top-input {
  margin-left: 25px;
}
.border-main {
  width: 400px;
  height: 80px;
  margin-left: 20%;
}
.border-main > h5 {
  color: #161a1e;
  font-size: 15px;
  margin-top: 15%;
}
.border-main > h5 b {
  color: #e4393c;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/topdetail.vue